import React, { Component } from 'react';
import axios from 'axios';
import $ from 'jquery';
import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import PurchaseModal from './purchaseModal';

const BASE_URL = "https://api.proyectoshark.com/games/public/games";

class Games extends Component {
    state = {
        data: [],
        isLoaded: false,
        modalOpen: false,
        selectedGame: null
    }

    componentDidMount() {
        axios.get(`${BASE_URL}`)
            .then(res => {
                this.setState({
                    data: res.data,
                    isLoaded: true,
                })
            })
            .catch(err => console.log(err))
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.isLoaded) {
            this.state.data.forEach((game, index) => {
                const $carousel = $('.app-screenshots-' + index)

                if ($carousel.hasClass('slick-initialized')) {
                    $carousel.slick('unslick')
                }

                $carousel.slick({
                    dots: true,
                    arrows: false,
                    speed: 2000,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                    autoplaySpeed: 3000,
                    pauseOnHover: true,
                    pauseOnFocus: false,
                    responsive: [
                        { breakpoint: 1024, settings: { slidesToShow: 1, slidesToScroll: 1 } },
                        { breakpoint: 600, settings: { slidesToShow: 1, slidesToScroll: 1, dots: false } },
                        { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1, dots: false } },
                    ],
                })
            })
        }
    }

    openModal = () => {
        this.setState({ modalOpen: true })
    }

    closeModal = () => {
        this.setState({ modalOpen: false })
    }

    render() {
        return (
            <section className="section about-app-area ptb_50">
                {this.state.data.length > 0 && this.state.data.map((game, index) => {
                    return <div className="container game-card" key={`game_${index}`}>
                        <div className="row align-items-center">
                            <div className="col-12 col-lg-6">
                                {/* About Text */}
                                <div className="about-text">
                                    {/* Headings */}
                                    <div className="headings d-flex align-items-center mb-4">
                                        <h2 className="text-uppercase">{game.title}</h2>
                                    </div>
                                    <p className="d-sm-block my-3">{game.description}</p>
                                </div>
                            </div>

                            <div className="col-12 col-lg-6 p-0">
                                <section id="screenshots" className="section screenshots-area">
                                    {/* App Screenshot Slider Area */}
                                    <div className={`app-screenshots-` + index}>
                                        {/* Single Screenshot Item */}
                                        {Array.isArray(game.images) &&
                                            game.images.length > 0 &&
                                            game.images.map((item, idx) => {
                                                return (
                                                    <div key={`sd_${idx}`} className="single-screenshot">
                                                        <img src={item} alt="" />
                                                        <div className="screenshots-overlay">
                                                            <a href={item} data-fancybox="images">
                                                                <i className={'icofont-image'} />
                                                            </a>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                    </div>
                                </section>
                            </div>
                        </div>
                        <div className="row">
                            <div className={parseInt(game.sold) >= 100 ? "col-12 col-lg-12" : "col-12 col-lg-10"}>
                                <h5 className="text-uppercase">Números Vendidos {game.sold}%</h5>
                                <div className="progress-wrapper">
                                    <div className="progress-bar">
                                        <div
                                            className="progress-fill"
                                            style={{ '--progress': `${game.sold}%` }}
                                        ></div>
                                    </div>
                                </div>

                            </div>
                            {parseInt(game.sold) < 100 && <div className="col-12 col-lg-2 d-flex align-items-center justify-content-center">
                                <div className="start-free-btn mt-4 mt-lg-0 w-100">
                                    <button
                                        className="btn mt-3 mt-sm-4 w-100"
                                        type="button"
                                        disabled={game.sold >= 100}
                                        onClick={() => this.setState({ modalOpen: true, selectedGame: game })}
                                    >
                                        COMPRAR
                                    </button>
                                </div>
                            </div>}
                            {parseInt(game.sold) >= 100 && <div className="col-12 col-lg-12 d-flex align-items-center justify-content-center">
                                <p className="d-none d-sm-block my-3">
                                    ¡LO SENTIMOS, LOS NÚMEROS AGOTARON!, LOS PREMIOS SE JUGARÁN CON LOS NUMEROS DE LA LOTERIA NACIONAL
                                </p>
                            </div>}
                        </div>
                        {game.privileged_numbers.length > 0 && <div className="row mt-3">
                            <div className="col-12">
                                <h4 className="text-uppercase">Numeros Shark</h4>
                                <p className="d-none d-sm-block my-3">
                                    ¡Hay {game.privileged_numbers.length} números shark con premios en efectivo! Realiza tu compra y revisa si tienes uno de los siguientes números y ganas automáticamente,los primeros en sacar los números shark ganaran los premios mayores
                                </p>
                            </div>
                            <div className="col-12 d-flex flex-wrap justify-content-center">
                                {game.privileged_numbers.map((item, idx) => (
                                    <div key={`ao_${idx}`} className="number-item">
                                        <p className="mb-0">
                                            <span
                                                style={{
                                                    textDecoration: item.purchased ? 'line-through' : 'none',
                                                    display: 'block',
                                                    fontSize: '1.2rem',
                                                }}
                                            >
                                                {item.number.toString().padStart(game.max_digits, '0')}
                                            </span>
                                            {item.delivered && <span style={{ fontSize: '0.75rem', fontWeight: 400 }}>Entregado</span>}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>}
                    </div>
                })}
                <PurchaseModal isOpen={this.state.modalOpen} onClose={this.closeModal} game={this.state.selectedGame} />
            </section>
        );
    }
}

export default Games;